import React from 'react';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start'
    }
}));

export default function AppMenu(props) {
    const {
        children,
        className
    } = props;
    const classes = useStyles();

    return (
        <div className={`${classes.root} ${className || ''}`}>
            {children}
        </div>
    );
};
